import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import {datePipe,dateTimePipe,MomentDatePipe, UTCToEST} from "./datePipe"; // <---

@NgModule({
  declarations:[datePipe,dateTimePipe,MomentDatePipe, UTCToEST], // <---
  imports:[CommonModule],
  exports:[datePipe,dateTimePipe,MomentDatePipe, UTCToEST] // <---
})

export class datePipeModule{
    static forRoot() {
        return {
            ngModule: datePipeModule,
            providers: [],
        };
     }
}